<template>
  <!-- 网媒管理系统申请试用 -->
  <div class="wm-apply-box border_box">
    <iframe :src="pageUrl"></iframe>
  </div>
</template>
<script>
export default {
  name:'wmapply',
  data(){
    return {
      pageUrl: 'https://www.fxiaoke.com/proj/page/marketing-page?id=a950c688e02548718e25e30c5fa78d18&authCode=6bb2b56a2b5937e00e19e26f605de709&marketingEventId=6498f08274c75200018e92cf&marketingActivityId=64d358c24f4cf2000112eaa2&spreadChannel=offiaccount&wxAppId=wx06ee62e66fb1b1ea&byshare=1&type=1&fsUserId=1089'
    }
  },
  created(){
    // 申请试用页面，更改网页ico
    let pageUrl = this.$route.path
    if(pageUrl === '/wmapply'){
      document.querySelector("link.linkico").href = "./wmico.ico";
    }else{
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  computed: {
   
  },
  mounted(){
    
  },
  methods:{
  }
}
</script>

<style scoped>
.wm-apply-box {
  height: 100vh;
  background: #f2f3f7;
}
.wm-apply-box iframe {
  display: block;
  border: none;
  width: 100%;
  height: 100%;
}
</style>